import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <>
      <Link
        to={`/categories/${item?.slug || item?.slugPath}`}
        className="custom-ax-pkh-cat-sec-card group relative block overflow-hidden rounded-[20px] bg-white p-4 text-decoration-none transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
      >
        {/* Image Wrapper with Square Aspect Ratio and Light Textured Background */}
        <div className="custom-ax-pkh-cat-sec-img-wrap relative aspect-square w-full overflow-hidden rounded-[16px] bg-[#FBF9F6] border border-[#F0EAE0] flex items-center justify-center p-3">
          {/* The actual image, now perfectly round */}
          <img
            src={item?.image}
            alt={item?.name}
            className="custom-ax-pkh-cat-sec-img h-full w-full rounded-full object-cover object-center transition-transform duration-500 ease-in-out group-hover:scale-105 shadow-inner"
          />
          
          {/* A subtle overlay effect on hover */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#4B3226]/20 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        </div>

        {/* Title, Subtitle and Animated Arrow Section */}
        <div className="mt-5 flex items-center justify-between px-1">
          <div className="flex flex-col">
            <h3 className="custom-ax-pkh-cat-sec-title font-sans text-xl font-semibold tracking-tight text-[#2E211A] transition-colors duration-300 group-hover:text-[#A6472E] m-0">
              {item?.name}
            </h3>
            {/* Subtitle Added and refined */}
            {(item?.subtitle || item?.description) && (
              <p className="custom-ax-pkh-cat-sec-subtitle text-sm text-[#7A6B63] mt-1.5 line-clamp-1 transition-colors duration-300 group-hover:text-[#8C3A25] m-0">
                {item?.subtitle || item?.description}
              </p>
            )}
          </div>
          
          {/* The Arrow Button - Vertically centered with the entire text block */}
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#FBF9F6] text-[#A6472E] transition-all duration-300 group-hover:bg-[#A6472E] group-hover:text-[#FFFFFF] group-hover:translate-x-1 shadow-sm">
            <svg 
              className="h-4 w-4" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor" 
              strokeWidth="2.5"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </span>
        </div>
      </Link>
    </>
  );
}

export default Card;